import React from 'react';
import pricingData from '../data/pricingData.json';
import '../App.scss';

const Pricing = () => {
  return (
    <section className="pricing page-section">
      <span className="section-label">Hinnasto</span>
      <h1 className="section-heading">{pricingData.title}</h1>
      {pricingData.intro && (
        <p className="section-subtitle">{pricingData.intro}</p>
      )}
      {pricingData.note && (
        <p className="pricing-note">{pricingData.note}</p>
      )}
      <div className="pricing-grid">
        {pricingData.categories.map((category, index) => (
          <article key={category.title + index} className="pricing-card">
            <h2>{category.title}</h2>
            {category.tagline && <p className="pricing-tagline">{category.tagline}</p>}
            <p>{category.description}</p>
            {category.price && (
              <p>
                <strong>{category.price}</strong>
              </p>
            )}
            {category.deliverables && (
              <ul>
                {category.deliverables.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            )}
            {category.additional && <p>{category.additional}</p>}
          </article>
        ))}
      </div>

      {pricingData.addOns && pricingData.addOns.length > 0 && (
        <>
          <h2 className="section-heading addons-heading">Lisäpalvelut</h2>
          <div className="pricing-grid">
            {pricingData.addOns.map((addon) => (
              <article key={addon.title} className="pricing-card">
                <h3>{addon.title}</h3>
                <p>{addon.description}</p>
                {addon.pricing && (
                  <ul>
                    {addon.pricing.map((item) => (
                      <li key={`${addon.title}-${item.task}`}>
                        <strong>{item.task}:</strong> {item.price}
                      </li>
                    ))}
                  </ul>
                )}
                {addon.contact && <p>{addon.contact}</p>}
              </article>
            ))}
          </div>
        </>
      )}
    </section>
  );
};

export default Pricing;
